export const GROUND = {
  city: 1,
  village: 2,
};

export const EDU_TYPE = {
  additional: 1,
  general: 2,
  preschool: 3,
  professional: 4,
  higher: 5,
  atypical: 6,
  extra: 7,
  sport: 8,
  none: 9,
};

export const EDU_TYPE_DATA = {
  [EDU_TYPE.additional]: {
    id: EDU_TYPE.additional,
    name: 'Организация дополнительного образования',
  },
  [EDU_TYPE.general]: {
    id: EDU_TYPE.general,
    name: 'Общеобразовательная организация',
  },
  [EDU_TYPE.preschool]: {
    id: EDU_TYPE.preschool,
    name: 'Дошкольная образовательная организация',
  },
  [EDU_TYPE.professional]: {
    id: EDU_TYPE.professional,
    name: 'Профессиональная образовательная организация',
  },
  [EDU_TYPE.higher]: {
    id: EDU_TYPE.higher,
    name: 'Организация высшего образования',
  },
  [EDU_TYPE.atypical]: {
    id: EDU_TYPE.atypical,
    name: 'Нетиповая образовательная организация',
  },
  [EDU_TYPE.extra]: {
    id: EDU_TYPE.extra,
    name: 'Организация дополнительного профессионального образования',
  },
  [EDU_TYPE.sport]: {
    id: EDU_TYPE.sport,
    name: 'Организация спортивной подготовки',
  },
  [EDU_TYPE.none]: {
    id: EDU_TYPE.none,
    name: 'Не является образовательной организацией',
  },
};

export const GROUND_DATA = {
  [GROUND.city]: {
    id: GROUND.city,
    name: 'Городская',
  },
  [GROUND.village]: {
    id: GROUND.village,
    name: 'Сельская',
  },
};
